import React, { useMemo, useState } from 'react';
import { Box, Button } from '@mui/material';
import { SortFilterDialog, SortFilterMode, SortFilterOption, SortFilterValue } from './SortFilterDialog';

interface Props {
  mode: SortFilterMode;
  fields: SortFilterOption[];
  activeFields?: SortFilterValue[];
  onApply: (items: SortFilterValue[]) => void;
  buttonId?: string;
  buttonSx?: Record<string, unknown>;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const getButtonLabel = (mode: SortFilterMode) => (mode === 'sort' ? 'SORT COLUMNS' : 'FILTER COLUMNS');

export const SortFilterControl: React.FC<Props> = ({
  mode,
  fields,
  activeFields = [],
  onApply,
  buttonId,
  buttonSx,
  open: controlledOpen,
  onOpenChange,
}) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const open = controlledOpen ?? internalOpen;
  const setOpen = (next: boolean) => {
    setInternalOpen(next);
    onOpenChange?.(next);
  };

  const hasActiveRules = activeFields.length > 0;
  const dialogTitle = useMemo(() => `${mode[0].toUpperCase()}${mode.slice(1)} table columns`, [mode]);

  return (
    <>
      <Button
        id={buttonId}
        variant="outlined"
        onClick={() => setOpen(true)}
        sx={{
          ...buttonSx,
          ...(hasActiveRules ? { borderColor: '#0c479d', color: '#0c479d', fontWeight: 700 } : {}),
        }}
      >
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
          <span>{getButtonLabel(mode)}</span>
          {hasActiveRules && (
            <Box
              component="span"
              sx={{
                minWidth: 20,
                px: 0.75,
                py: 0.125,
                borderRadius: 10,
                fontSize: 12,
                fontWeight: 700,
                lineHeight: '16px',
                textAlign: 'center',
                color: 'white',
                backgroundColor: '#0c479d',
              }}
            >
              {activeFields.length}
            </Box>
          )}
        </Box>
      </Button>

      <SortFilterDialog
        open={open}
        mode={mode}
        fields={fields}
        activeFields={activeFields}
        title={dialogTitle}
        onClose={() => setOpen(false)}
        onApply={(items) => {
          onApply(items);
          setOpen(false);
        }}
      />
    </>
  );
};
